export interface KpiDefinition {
  position: 1 | 2 | 3 | 4;
  /** Label rendered in the eyebrow row of the KPI card. */
  label: string;
  /** Default footer copy when no value is yet available. */
  emptyFooter: string;
}

export const PER_AGENT_KPIS: readonly KpiDefinition[] = [
  { position: 1, label: "Tasks completed", emptyFooter: "No tasks completed yet" },
  { position: 2, label: "Last active", emptyFooter: "No activity yet" },
  { position: 3, label: "Scheduled jobs", emptyFooter: "No active scheduled jobs" },
  { position: 4, label: "Memory entries", emptyFooter: "No memory entries yet" },
];

export const EMPTY_KPI_VALUE = "—";
